import { Component, HostListener, input, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {
	faFileContract,
	faLandmark,
	faServer,
	faUser,
} from '@fortawesome/free-solid-svg-icons';
import { IconComponent } from '@infodocs/shared/components/icon/icon.component';

@Component({
	selector: 'app-portfolio-nav-dropdown',
	templateUrl: './portfolio-nav-dropdown.component.html',
	styleUrls: ['./portfolio-nav-dropdown.component.scss'],
	imports: [RouterLink, RouterLinkActive, IconComponent],
})
export class PortfolioNavDropdownComponent {
	public readonly companiesRoute = input.required<string[]>();

	protected readonly menuId = 'portfolio-nav-dropdown-menu';
	protected readonly isOpen = signal(false);
	protected readonly faServerIcon = faServer;
	protected readonly faLandmarkIcon = faLandmark;
	protected readonly faFileContractIcon = faFileContract;
	protected readonly faUserIcon = faUser;
	protected readonly trustsLink = ['/portfolio', 'trust'] as const;

	@HostListener('document:click', ['$event'])
	protected onDocumentClick(event: MouseEvent): void {
		const target = event.target as HTMLElement | null;
		if (!target?.closest('.portfolio-nav-dropdown')) {
			this.closeMenu();
		}
	}

	@HostListener('document:keydown.escape')
	protected onEscapeKey(): void {
		this.closeMenu();
	}

	protected toggleMenu(): void {
		this.isOpen.update(open => !open);
	}

	protected closeMenu(): void {
		this.isOpen.set(false);
	}
}
